import React, { useMemo } from "react";
import { Link } from "react-router-dom";
import PageLastUpdated from "../../../components/shared/PageLastUpdated";
import { getDateUpdate } from "../../../Utils/utils";
import { useGetHtmlApiQuery } from "../../../redux/services/apiHome";
import { useSelector } from "react-redux";

const AzadiKaAmritMahotsav = () => {
  const { languageType } = useSelector((state) => state.homeSlice);

  const { data: AkamHtml = {} } = useGetHtmlApiQuery({
    url: 28752,
    lang: languageType,
  });

  const pageBody = AkamHtml?.body?.[0]?.value ?? "No content available";

  const lastUpdatedOn = useMemo(() => {
    return getDateUpdate(AkamHtml?.changed?.[0]?.value);
  }, [AkamHtml]);

  return (
    <div className="container">
      <div className="container power-section ">
        <div dangerouslySetInnerHTML={{ __html: pageBody }}></div>
        <PageLastUpdated lastUpdatedOn={lastUpdatedOn} />
      </div>
    </div>
  );
};

export default AzadiKaAmritMahotsav;
